import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import pageMixin from "../mixins/page";
import Axios from "axios";
import SNSModal from "./SNSModal.vue";
import { setTimeout } from 'timers';
export default {
  name: "sns-list",
  mixins: [pageMixin],
  components: {
    SNSModal: SNSModal
  },
  data: function data() {
    return {
      searchText: "",
      columns: [{
        title: "客户名称",
        sortable: true,
        key: "client_name"
      }, {
        title: "硬件版本",
        key: "hardware_version",
        sortable: true
      }, {
        title: "产品ID",
        key: "no",
        sortable: false
      }, {
        title: "产品语言",
        key: "lang",
        sortable: true
      }, {
        title: "激活接口",
        sortable: true,
        key: "license_interface",
        render: function render(h, params) {
          return h('div', [h('span', {
            style: {
              display: 'inline-block',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            },
            domProps: {
              title: params.row.license_interface ? JSON.stringify(params.row.license_interface) : ""
            }
          }, params.row.license_interface ? JSON.stringify(params.row.license_interface) : "")]);
        }
      }, {
        title: "有效期（月）",
        sortable: true,
        key: "licensed_months"
      }, {
        title: "授权点数",
        sortable: true,
        key: "licensed_num"
      }, {
        title: "产品介质",
        sortable: false,
        key: "media_type"
      }, {
        title: "产品标识",
        sortable: true,
        key: "product_key"
      }, {
        title: "产品名称",
        key: "product_name",
        sortable: true
      }, {
        title: "软件版本",
        key: "software_version",
        sortable: true
      }, {
        title: "创建时间",
        key: "create_time",
        sortable: true
      }, {
        title: "下载授权",
        slot: "download"
      }],
      data: [],
      selection: [],
      showAddModal: false
    };
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      var _this = this;
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      Axios.get("activation/sns/", {
        params: {
          name: this.searchText,
          order_by: this.sortKey,
          page: this.currentPage,
          per_page: this.pageSize
        }
      }).then(function (resp) {
        _this.data = resp.data.sns;
        _this.setPageVars(resp.data.page_info);
      }).then(onFinish, onFinish);
    },
    onModalClose: function onModalClose(val) {
      val && this.refresh();
    },
    onSelectionChange: function onSelectionChange(rows) {
      var _this$selection;
      this.selection.length = 0;
      (_this$selection = this.selection).push.apply(_this$selection, _toConsumableArray(rows));
    }
  }
};